<template>
    <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
        <div class="text-[#414141] font-sans">
            <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">
                Overview
                <VideoPlayIcon 
                    :videoSrc="'/videos/Module_3.mp4'"
                    :size="24"
                    iconClass="mb-1"
                />
            </h3>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">An <span class="font-bold">aspirational vision</span> defines the world your organization strives to help create; a future that reflects your deepest purpose and impact. It articulates the broad transformation you seek in society and how your organization is positioned to contribute to that change. Your aspirational vision is not a promise of what your organization alone will achieve, but rather a bold picture of the change you are committed to advancing.</p>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">Creating an aspirational vision of the future requires a willingness to dream big and take risks. It involves challenging the status quo and embracing new ideas and approaches. By doing so, individuals and organizations can inspire others to join them in their pursuit of a better future, creating a shared sense of purpose and a collective effort to achieve it. Organizational leadership (Executive Director and Board) should be in alignment with an organization's aspirational vision.</p>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]"> A <span class="font-bold">mission statement </span>is a concise and powerful statement that guides your organization's strategic decisions, program development, resource allocation, and overall direction. Mission statements should communicate what your organization does in a simple sentence that is understandable to a wide audience.</p>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">The following module will guide you in the development of your organization's mission statement and aspirational vision.</p>
        </div>
    </div>
</template>

<script setup>
import { useStepValidation } from '@/composables/useStepValidation'; // Import the validation composable
import VideoPlayIcon from '@/components/VideoPlayIcon.vue';
// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>

</style>
